module.exports = __webpack_public_path__ + "img/11552312000710.ef85ee17.png";